import { useState } from "react";

import {
  ButtonsWrapper,
  StartWrapper,
  StartButton,
  ButtonComponent,
  ButtonImage,
} from "@/commands/AIConcierge/assistant.style";
import { ChatArea } from "@/commands/AIConcierge/chatAreaComponent";
import { ConversationNode } from "@/commands/AIConcierge/types";
import homeIcon from "@/public/AIConcierge/icon_home.svg";
import previousIcon from "@/public/AIConcierge/icon_modoru.svg";

type Props = {
  updateCharacterByPattern: (node: ConversationNode) => void;
  setShowCharacterComment: React.Dispatch<React.SetStateAction<boolean>>;
  resetCharacterState: () => void;
};

export function Assistant({
  updateCharacterByPattern,
  setShowCharacterComment,
  resetCharacterState,
}: Props) {
  const [isStarted, setIsStarted] = useState<boolean>(false);

  const [showStartButton, setShowStartButton] = useState<boolean>(true);
  const [showButtonsWrapper, setShowButtonsWrapper] = useState<boolean>(false);
  const [isChoiceSelected, setIsChoiceSelected] = useState(false);
  const [navigationHandlers, setNavigationHandlers] = useState<{
    goToStart: () => void;
    goBack: () => void;
    canGoBack: boolean;
  } | null>(null);

  if (!isStarted) {
    return (
      <StartWrapper>
        <StartButton
          type="button"
          style={{
            opacity: showStartButton ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          onClick={() => {
            setTimeout(() => {
              setShowCharacterComment(false);
              setShowStartButton(false);
            }, 500);

            setTimeout(() => {
              setIsStarted(true);
              setShowCharacterComment(true);
              // setShowButtonsWrapperはChatAreaのuseEffectで管理されるため、ここでは呼ばない
            }, 1000);
          }}
        >
          START
        </StartButton>
      </StartWrapper>
    );
  }

  const handleGoToStart = () => {
    if (!navigationHandlers) {
      return;
    }

    setIsChoiceSelected(true);
    // まず非表示にする（他の表示と同じタイミングに合わせる）
    setTimeout(() => {
      setShowCharacterComment(false);
      setShowButtonsWrapper(false);
    }, 500);

    // 1000ms後に表示（他の表示と同じタイミング）
    setTimeout(() => {
      navigationHandlers.goToStart();
      resetCharacterState();
      setShowCharacterComment(true);
      setShowStartButton(true);
      setIsStarted(false);
      setIsChoiceSelected(false);
    }, 1000);
  };

  const handleGoBack = () => {
    if (!navigationHandlers) {
      return;
    }

    if (!navigationHandlers.canGoBack) {
      handleGoToStart();
      return;
    }

    setIsChoiceSelected(true);
    setShowButtonsWrapper(false);
    // setShowButtonsWrapperはChatAreaのuseEffectで管理されるため、ここでは呼ばない
    setTimeout(() => {
      navigationHandlers.goBack();
    }, 500);
  };

  return (
    <>
      <ButtonsWrapper
        style={{
          opacity: showButtonsWrapper ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
        }}
      >
        <ButtonComponent type="button" onClick={handleGoToStart} $isHome>
          <ButtonImage src={homeIcon} />
          最初に
          <br />
          戻る
        </ButtonComponent>
        <ButtonComponent
          type="button"
          onClick={handleGoBack}
          disabled={!navigationHandlers}
          $isHome={false}
        >
          <ButtonImage src={previousIcon} />
          ひとつ
          <br />
          戻る
        </ButtonComponent>
      </ButtonsWrapper>

      <ChatArea
        updateCharacterByPattern={updateCharacterByPattern}
        setNavigationHandlers={setNavigationHandlers}
        isChoiceSelected={isChoiceSelected}
        setIsChoiceSelected={setIsChoiceSelected}
        setShowButtonsWrapper={setShowButtonsWrapper}
        setShowCharacterComment={setShowCharacterComment}
      />
    </>
  );
}
